/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/prop-types */
import React, { useRef, useEffect } from 'react';
// import { useSafeAreaInsets } from 'react-native-safe-area-context';
import {
  Animated,
  TouchableOpacity,
  StyleSheet,
  Dimensions,
} from 'react-native';
import { Portal } from '@gorhom/portal';
import { isWeb, isMobileWeb } from '~global/screens';
import Colors from '~global/Colors';

const dimension = Dimensions.get('window');

const Modal = (props) => {
  const {
    closeOutside = true,
    style,
    isVisible,
    fullPage,
    transparent,
    width,
    maxWidth,
    animationType,
    children,
    isBottomSheet,
    onClose = () => {},
  } = props;

  // const insets = useSafeAreaInsets();
  const modalHeight =
    dimension.height - (fullPage && isMobileWeb ? 0 : !isWeb ? 0 : 55);

  const fadeIn = useRef(new Animated.Value(0)).current;
  const fadeContentIn = useRef(new Animated.Value(0)).current;
  const slideIn = useRef(new Animated.Value(1000)).current;

  const onClosePopup = () => {
    try {
      Animated.parallel([
        Animated.timing(fadeIn, {
          toValue: 0,
          duration: 250,
          useNativeDriver: false,
        }),
        Animated.timing(slideIn, {
          toValue: 1000,
          duration: 500,
          useNativeDriver: false,
        }),
        Animated.timing(fadeContentIn, {
          toValue: 0,
          duration: 250,
          useNativeDriver: false,
        }),
      ]).start();
      setTimeout(() => {
        onClose();
      }, 500);
    } catch (error) {}
  };

  useEffect(() => {
    if (isWeb || isMobileWeb) {
      if (isVisible) {
        document.body.style.overflow = 'hidden';
        Animated.parallel([
          Animated.timing(fadeIn, {
            toValue: 1,
            duration: 250,
            useNativeDriver: false,
          }),
          Animated.timing(slideIn, {
            toValue: 0,
            duration: 500,
            useNativeDriver: false,
          }),
          Animated.timing(fadeContentIn, {
            toValue: 1,
            duration: 250,
            useNativeDriver: false,
          }),
        ]).start();
      } else {
        document.body.style.overflow = 'auto';
      }
    }
  }, [props]);

  return isVisible ? (
    <Portal>
      <React.Suspense fallback={<></>}>
        <Animated.View
          style={{
            ...StyleSheet.absoluteFillObject,
            position: 'fixed',
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            zIndex: 9,
            paddingTop: isMobileWeb ? 0 : 25,
            alignItems: isMobileWeb
              ? fullPage
                ? 'initial'
                : 'flex-end'
              : 'flex-start',
            justifyContent: 'center',
            flexDirection: 'row',
            opacity: fadeIn,
          }}>
          <TouchableOpacity
            activeOpacity={1}
            style={styles.modalOverlay}
            onPress={() => (closeOutside ? onClosePopup() : false)}
          />
          <Animated.View
            style={{
              ...(animationType == 'slide'
                ? {
                    transform: [
                      {
                        translateY: slideIn,
                      },
                    ],
                  }
                : {
                    opacity: fadeContentIn,
                  }),
              backgroundColor: transparent ? 'transparent' : Colors.white,
              width: fullPage && isMobileWeb ? '100%' : width || 'auto',
              maxWidth: isWeb ? maxWidth || 'auto' : dimension.width,
              maxHeight: modalHeight || 'auto',
              borderRadius: 5,
              position: 'relative',
              zIndex: 10,
              ...(isBottomSheet
                ? { maxWidth }
                : { margin: fullPage && isMobileWeb ? 'initial' : 'auto' }),
              ...style,
            }}>
            {children}
          </Animated.View>
        </Animated.View>
      </React.Suspense>
    </Portal>
  ) : (
    false
  );
};

const styles = StyleSheet.create({
  modal: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 9,
    paddingTop: isMobileWeb ? 0 : 25,
    alignItems: isMobileWeb ? 'flex-end' : 'flex-start',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  modalContainer: {
    borderRadius: 5,
    position: 'relative',
    zIndex: 10,
    margin: 'auto',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    backgroundColor: Colors.overlay,
  },
});

export default Modal;
